<template>
  <div class="app-separator">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppSeparator',
}
</script>

<style scoped>
.app-separator {
  height: 1px;
  margin: 0 -20px 23px;
  background: var(--c-secondary-400);
}
</style>
